import { useEffect, useState } from "react";
import { RiGroupLine } from "react-icons/ri";
import fetchBySegment from "../../../services/fetchBySegment";
import CustomerPanel from "./CustomerPanel";

export default function SegmentWidget({ name, id, refetch }: any) {
  const [isVisible, setVisible] = useState<boolean>(false);
  const [customers, setCustomers] = useState<any>([]);

  const handleFetchCustomers = async () => {
    const response = await fetchBySegment(id);
    setCustomers(response?.payload);
  };

  const handleRefetch = () => {
    handleFetchCustomers();
  };

  useEffect(() => {
    handleFetchCustomers();
  }, []);

  return (
    <div className="col-span-12 md:col-span-2 sm:col-span-2 border p-2 bg-white">
      <button
        className="flex justify-start"
        onClick={() => {
          setVisible(true);
        }}
      >
        <div className="bg-red-100 w-10 h-10 mr-2 flex justify-center items-center rounded-lg">
          <RiGroupLine />
        </div>
        <div className="flex flex-col items-start px-2 border-l">
          <div className="font-bold truncate w-40 flex justify-start">
            {name}
          </div>
          <div className="text-gray-500">{customers?.length}</div>
        </div>
      </button>
      <CustomerPanel
        isVisible={isVisible}
        setShowDetails={setVisible}
        customers={customers}
        title={`${name} Customers`}
        refetch={handleRefetch}
      />
    </div>
  );
}
